<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div class="form-element__checkbox" :class="classObject" @click="action">
      <input
        type="checkbox"
        :id="text"
        :name="text"
        @change="changed"
        v-model="val"
      />
      <label :for="text" @click="action"><slot></slot></label>
    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  computed: {
    classObject: function () {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-half": this.isHalf,
        "-checked": this.val,
      };

      return list;
    },
    text: function () {
      let _random = Math.floor(Math.random() * 999999) + 1;

      return `checkbox-${_random}`;
    },
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    changed: function (e) {
      this.$emit("input", e.target.checked);

      return e.target.checked;
    },
    action: function () {
      this.$emit("input", !this.val);
    },
  },
};
</script>